import { gql } from '@apollo/client';

export const checkOnlineCourses = gql`
  query checkOnlineCourses($coassemble_id: Int!) {
    online_courses(
      where: { coassemble_id: { _eq: $coassemble_id } }
      limit: 1
    ) {
      id
      name
      group_id
    }
  }
`;

export const insertOnlineCourseRow = gql`
  mutation insertOnlineCourseRow($data: online_courses_insert_input!) {
    insert_online_courses_one(object: $data) {
      id
    }
  }
`;
